/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_StarInputs */



/**
* | output |
* | --- |
* | "Star" |
*
* @param {Explorer_Info_Property_StarInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_star = /** @type {((inputs?: Explorer_Info_Property_StarInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_StarInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Favori")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Звезда")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estrella")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("星星")
	if (locale === "ja") return /** @type {LocalizedString} */ ("星")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तारा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estrela")
	return /** @type {LocalizedString} */ ("Star")
});